
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as mockuVX6mNLxzkl5UP4zDCwhzMiNTNMP7Z4HAJaD4Kzq7F0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/mock.vue?macro=true";
import { default as test1OvHCKW7lTddJxOROJhzwNkazDwMftu46oFvEpbifZcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/test.vue?macro=true";
import { default as index_45nyrkeD1MKL9RGWaeqA9xaUkLrqNLM6HNOnNZjPW75EMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/index.vue?macro=true";
import { default as indexa9US_bWE1q2Y8Jxyax8PaqTP5PDU2LzLZ4rP4Absmq4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/index.vue?macro=true";
import { default as slideCQjagG2zTbKvE6r6Tww38IWNJG4xRWbgv1SQGt3zV0sMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/slide.vue?macro=true";
import { default as preview0c_45Rh6huDOfTElxxrgb3u0mAoyy3xvlZHEXEjnfMC28Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/preview.vue?macro=true";
import { default as _91eventId_933nWOj2E3I4xuVWejJSRqdaGpVYWgtaL2i2Aic5P62r4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/[eventId].vue?macro=true";
import { default as previewImageTJS01dHRtX_qGvxqoJDE2ewT0CfJoUqzCnZevMOfvC8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/previewImage.vue?macro=true";
export default [
  {
    name: "mock",
    path: "/mock",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/mock.vue")
  },
  {
    name: "test",
    path: "/test",
    meta: test1OvHCKW7lTddJxOROJhzwNkazDwMftu46oFvEpbifZcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/index.vue")
  },
  {
    name: "present",
    path: "/present",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/index.vue")
  },
  {
    name: "present-slide",
    path: "/present/slide",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/slide.vue")
  },
  {
    name: "present-preview",
    path: "/present/preview",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/preview.vue")
  },
  {
    name: "present-eventId",
    path: "/present/:eventId()",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/[eventId].vue")
  },
  {
    name: "present-previewImage",
    path: "/present/previewImage",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/pages/present/previewImage.vue")
  }
]